/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".link[_ngcontent-%COMP%]{cursor:pointer!important;color:#0056b3!important;text-decoration:none!important}.link[_ngcontent-%COMP%]:active, .link[_ngcontent-%COMP%]:hover{text-decoration:underline!important}"];
export { styles as styles };
